// extracted by mini-css-extract-plugin
module.exports = {"form":"EmailCheck_form__P3AY5","serverError":"EmailCheck_serverError__w4wFi","terms":"EmailCheck_terms__MSGdw"};